export default function () {
  if (process.env.VUE_APP_SERVICE === "dev") {
    var VConsole = require("vconsole")
    //eslint-disable-next-line no-redeclare
    var VConsole = new VConsole()
  }
}
